import { render, staticRenderFns } from "./TaskDownloadLink.vue?vue&type=template&id=9dc0a962&scoped=true"
import script from "./TaskDownloadLink.vue?vue&type=script&lang=js"
export * from "./TaskDownloadLink.vue?vue&type=script&lang=js"
import style0 from "./TaskDownloadLink.vue?vue&type=style&index=0&id=9dc0a962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc0a962",
  null
  
)

export default component.exports